<template>
    <div>
        <fieldset  class="form-group">
            <legend style="font-size: 1rem">{{ $t('Available Languages') }}</legend>
            <div class="form-check" v-for="locale in availableLocales">
                <label class="form-check-label">
                    <input class="form-check-input" type="checkbox"
                           id="frm-locales-available"
                           v-model="selectedLocales"
                           :value="locale"
                           :disabled="defaultLocale == locale"
                    >
                    {{ locale.label }}
                </label>
            </div>
        </fieldset>
        <div class="form-group">
            <label for="frmLocalesDefault">{{ $t('Default language') }}</label>
            <select class="form-control" v-model="defaultLocale" id="frmLocalesDefault">
                <option v-for="locale in selectedLocales" :value="locale">{{ locale.label }}</option>
            </select>
        </div>
        <input type="hidden" :name="nameLocalesSelected" :value="localesConfig">
        <input type="hidden" :name="nameDefaultLocale" :value="defaultLocaleConfig">
    </div>
</template>
<script>
    export default{
        props : {
            nameLocalesSelected : String,
            nameDefaultLocale : String,
            dataLocales : Array,
            dataDefaultLocale : String,
            availableLocales : {
                type : Array,
                default : []
            }
        },
        data: function(){
            return {
                selectedLocales: [],
                defaultLocale: undefined,
            }
        },
        computed: {
            localesConfig: function () {
                return this.selectedLocales.map((l) => l.value);
            },
            defaultLocaleConfig: function () {
                return this.defaultLocale?.value;
            }
        },
        watch: {
            selectedLocales: function(newselectedLocales) {
                if (
                  this.defaultLocale === undefined
                  || ! [...this.selectedLocales].find((locale) => locale.value === this.defaultLocale.value)
                ) {
                    this.defaultLocale = this.selectedLocales[0];
                }
            }
        },
        mounted() {
            this.selectedLocales = this.availableLocales.filter(
              (locale) => this.dataLocales.map((l) => l.value).includes(locale.value)
            );
            this.defaultLocale = this.availableLocales.find((l) => l.value === this.dataDefaultLocale);
        }
    }
</script>


